//TODO: GROW-2166 when Productizing if fixed win update the InverseHeader in core component and fix imports
'use client';

import { RadialGradientBG } from '@jouzen/ecom-components';

import InverseHeader from '@/app/components/Experiments/FixedHeader/InverseHeader/InverseHeader';
import landingPageBodyGradients from '@/app/components/LandingPage/_data/landingPageBodyGradients/landingPageBodyGradients';
import useScrollTracking from '@/app/hooks/useScrollTracking';

import StressBlog from './_components/StressBlog/StressBlog';
import StressFeatures from './_components/StressFeatures/StressFeatures';
import StressHero from './_components/StressHero/StressHero';
import StressIntegrations from './_components/StressIntegrations/StressIntegrations';
import StressJumbotron from './_components/StressJumbotron/StressJumbotron';
import StressTestimonials from './_components/StressTestimonials/StressTesimonials';

const Content = (): JSX.Element => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();

  return (
    <div data-cy="stress-page">
      <InverseHeader exit>
        <StressHero />
        <RadialGradientBG
          background="sandstone-200"
          className="overflow-hidden"
          gradients={landingPageBodyGradients}
        >
          <div className="relative">
            <StressFeatures />
            <StressJumbotron />
            <StressTestimonials />
            <StressIntegrations />
          </div>
        </RadialGradientBG>
      </InverseHeader>
      <InverseHeader enter>
        <StressBlog />
      </InverseHeader>
    </div>
  );
};

export default Content;
